import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { PositionService } from 'src/app/services/position.service';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { RELOAD_POSITIONS_KEY } from 'src/app/util/storage-util';

@Component({
  selector: 'app-invalid-job-modal',
  templateUrl: './invalid-job-modal.component.html',
  styleUrls: ['./invalid-job-modal.component.scss'],
})
export class InvalidJobModalComponent implements OnInit {

  @Input() headerIcon: string;
  @Input() headerText: string;
  @Input() bodyText: BodyText[];
  @Input() buttonText: string;
  @Input() shouldNavigateBrowseJobs: boolean = false;
  @Input() isJobDirectInvite?: boolean = false;
  @Input() jobExternalId?: string;

  constructor(private modalCtrl: ModalController,
              private readonly navCtrl: NavController,
              private readonly positionService: PositionService,
              private readonly segmentCMOS: SegmentCMOSService,
              private readonly storage: Storage) { }

  ngOnInit() {}

  async onClick() {
    await this.modalCtrl.dismiss();

    if (this.shouldNavigateBrowseJobs) {
      await this.navCtrl.navigateRoot(AppRoutingUtil.HOME);
      await this.navCtrl.navigateForward(AppRoutingUtil.BROWSE_JOBS);
    }
  }
}

export interface BodyText {
  text: string;
  class?: string;
};
